export const QueryKeys = {
    GetPayments: 'get-payments',
    GetAllPayments: 'get-all-payments',
    GetPaymentsMethods: 'get-payments-methods',
}
